// Polyfills primeiro: nada que rode depois pode encontrar a API faltando.
import './config/polyfills';

// Sentry deve ser inicializado antes de qualquer outro código
import { initSentry } from './config/sentry';
initSentry();

import './config/i18n';

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { migrateLegacyShell } from './utils/legacyShell';

// Antes do render: converte a navegação que vivia em localStorage numa URL.
migrateLegacyShell();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
